
<div class="modal right" id="updateOrder" tabindex="-1" role="dialog" aria-labelledby="updateOrderLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header bg-light">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title fs18" id="updateOrderLabel" ng-if="newOrderData.id">KargoGüncelle</h4>
                <h4 class="modal-title fs18" id="updateOrderLabel" ng-if="!newOrderData.id">Yeni Kargo</h4>
            </div>
            <form class="mt20" name="newWork" ng-submit="saveCustomerWork(newWork.$valid)">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="input-group">
                                <input type="text" ng-model="newOrderData.name" placeholder="KargoAçıklaması " class="form-control input-md" required>
                                <span class="input-group-addon danger">
                                    <a href="#" class="hint--medium hint--top-left" aria-label="Kargohakkında detaylar girebilir veya not tutabilirsiniz."><i class="fa fa-question-circle"></i> </a>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div id="map-order" style="height: 220px"></div>
                        <p class="help-block">* Harita üzerindeki ikonu sürükleyerek'te adresi seçebilirsiniz.</p>
                    </div>
                        
                    <div class="col-md-6">
                        <label class="control-label w400">Start Info
                            <a href="#" class="hint--medium hint--top-left" aria-label="Start address information."><i class="fa fa-question-circle"></i> </a> 
                        </label>
                        <div class="form-group">
                            <div class="input-group">
                                <input 
                                google-place 
                                ng-model="newOrderData.startAddress.address"
                                ng-change="addressSelected(newOrderData.startAddress,'start')" 
                                id="googlePlaceInput" 
                                class="form-control input-md" 
                                placeholder="Adres" 
                                required/>
                                <span class="input-group-addon danger">
                                    <a href="#" class="hint--medium hint--top-left " aria-label="Adresin caddesini yazarak çıkan önermelerden size uygun olanı seçiniz. İsterseniz map üzerindeki ikonu sürükleyerekte gideceğiniz adresi seçebilirsiniz."><i class="fa fa-question-circle"></i> </a>
                                </span>
                            </div>
                        </div>
                        
                        <div class="col-md-6 pln prn">
                            <div class="form-group">
                                <input type="text" ng-model="newOrderData.startAddress.city" placeholder="İl" class="form-control input-md br0">
                            </div>
                        </div>

                        <div class="col-md-6 pln prn">
                            <div class="form-group">
                                <input type="text" ng-model="newOrderData.startAddress.district" placeholder="İlçe" class="form-control input-md br0">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="control-label w400">End Info
                            <a href="#" class="hint--medium hint--top-left" aria-label="End address information."><i class="fa fa-question-circle"></i> </a> 
                        </label>
                        <div class="form-group">
                            <div class="input-group">
                                <input 
                                google-place 
                                ng-model="newOrderData.endAddress.address" 
                                ng-change="addressSelected(newOrderData.endAddress,'end')" 
                                id="googlePlaceInput" class="form-control input-md" 
                                placeholder="Adres" required/>
                                <span class="input-group-addon danger">
                                    <a href="#" class="hint--medium hint--top-left " aria-label="Adresin caddesini yazarak çıkan önermelerden size uygun olanı seçiniz. İsterseniz map üzerindeki ikonu sürükleyerekte gideceğiniz adresi seçebilirsiniz."><i class="fa fa-question-circle"></i> </a>
                                </span>
                            </div>
                        </div>

                        <div class="col-md-6 pln prn">
                            <div class="form-group">
                                <input type="text" ng-model="newOrderData.endAddress.city" placeholder="İl" class="form-control input-md br0">
                            </div>
                        </div>

                        <div class="col-md-6 pln prn">
                            <div class="form-group">
                                <input type="text" ng-model="newOrderData.endAddress.district" placeholder="İlçe" class="form-control input-md br0">
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-3" ng-repeat="item in orderData.orderFields">
                        <label class="control-label">{{ item.name }} </label>
                        
                        <div ng-if="item.type == 'text'">
                            <input type="text"
                                ng-init="(result = searchInFieldsValues(item.id,newOrderData)) != '' ? newOrderData.fields[item.id] = result :''"
                                ng-model="newOrderData.fields[item.id]" 
                                class="form-control" 
                                placeholder="{{ item.name }}">
                        </div>
                        <div ng-if="item.type == 'number'">
                            <input type="text"
                                ng-init="(result = searchInFieldsValues(item.id,newOrderData)) != '' ? newOrderData.fields[item.id] = result :''"
                                ng-model="newOrderData.fields[item.id]" 
                                class="form-control" 
                                placeholder="{{ item.name }}">
                        </div>

                        <div ng-if="item.type == 'date'">
                            <input type="date"
                                ng-init="(result = searchInFieldsValues(item.id,newOrderData)) != '' ? newOrderData.fields[item.id] = result :''"
                                ng-model="newOrderData.fields[item.id]" 
                                class="form-control" 
                                format-date
                                placeholder="{{ item.name }}">
                        </div>
                        
                        <div ng-if="item.type == 'select'">
                            <select 
                                ng-init="(result = searchInFieldsValues(item.id,newOrderData)) != '' ? newOrderData.fields[item.id] = result :''"
                                ng-model="newOrderData.fields[item.id]"
                                class="form-control">
                                <option value="">Seçim Yapınız</option>
                                <option value="{{ field }}" ng-repeat="field in stringToArray(item.value)">{{ field }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer bg-light">
                    <button type="submit" class="btn pull-right btn-primary ">
                            Güncelle
                    </button>
                    <button type="button" class="btn pull-right btn-default ml10" data-dismiss="modal">İptal</button>
                </div>
            </form>
        </div>
    </div>
</div>
